import { render, staticRenderFns } from "./procesos.view.vue?vue&type=template&id=067f48d2"
import script from "./procesos.view.vue?vue&type=script&lang=js"
export * from "./procesos.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports